//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//type
import { completedClientReqType } from "./type/CompletedRoleType";
import { completedDriverReqType } from "./type/CompletedRoleType";
import { completedHostReqType } from "./type/CompletedRoleType";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const UpdateCompletedRole = async (data: completedClientReqType | completedDriverReqType | completedHostReqType, theme:string, id:number) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(`${baseURL}/profile/${theme}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": i18n.language,
        Authorization: `Bearer ${token}`,
        "X-HTTP-Method-Override": "PUT",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error(error.response?.data || error.message);
    throw error;
  }
};

